import React from 'react'
import PropTypes from 'prop-types'
import Table from 'react-bootstrap/Table'
import Badge from 'react-bootstrap/Badge'

const cityLine = ({ city, state, zip }) =>
  [[city, state].filter(Boolean).join(', '), zip].filter(Boolean).join(' ')

const RemitAddresses = ({ remitAddresses }) => {
  if (remitAddresses.length === 0) {
    return <p className="text-muted mb-0">No remit addresses on file for this vendor.</p>
  }

  return (
    <div className="w-100">
      <Table className="border border-light" size="sm" data-testid="remit-addresses-table">
        <thead className="border-bottom border-light">
          <tr>
            <th>Seq</th>
            <th>Name</th>
            <th>Address</th>
            <th>Email</th>
            <th>Payment Method</th>
            <th>Status</th>
          </tr>
        </thead>
        <tbody>
          {remitAddresses.map((remit) => (
            <tr key={remit.id} className={remit.is_active ? '' : 'text-muted'}>
              <td>{remit.sequence}</td>
              <td>
                {remit.name}
                {remit.dba && <div className="small text-muted">DBA {remit.dba}</div>}
              </td>
              <td>
                {[remit.address1, remit.address2, remit.address3].filter(Boolean).map((line) => (
                  <div key={line}>{line}</div>
                ))}
                <div>{cityLine(remit)}</div>
                {remit.country && <div>{remit.country}</div>}
              </td>
              <td>{remit.email}</td>
              <td>{remit.payment_method}</td>
              <td>
                <Badge bg="light" text={remit.is_active ? 'primary' : 'muted'}>
                  {remit.is_active ? 'Active' : 'Inactive'}
                </Badge>
                {remit.is_default && (
                  <Badge bg="light" text="primary" className="ms-1">
                    Default
                  </Badge>
                )}
                {remit.removed_on && (
                  <Badge
                    bg="light"
                    text="danger"
                    className="ms-1"
                    title={`Removed from the vendor master on ${remit.removed_on}`}
                    data-testid="remit-removed"
                  >
                    Removed
                  </Badge>
                )}
              </td>
            </tr>
          ))}
        </tbody>
      </Table>
    </div>
  )
}

RemitAddresses.propTypes = {
  remitAddresses: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      sequence: PropTypes.number,
      name: PropTypes.string,
      address1: PropTypes.string,
      address2: PropTypes.string,
      address3: PropTypes.string,
      city: PropTypes.string,
      state: PropTypes.string,
      zip: PropTypes.string,
      country: PropTypes.string,
      email: PropTypes.string,
      dba: PropTypes.string,
      payment_method: PropTypes.string,
      is_active: PropTypes.bool,
      is_default: PropTypes.bool,
      removed_on: PropTypes.string
    })
  ).isRequired
}

export default RemitAddresses
